import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const bodyTemplate = htmlE`
  <style>
    .key-value-form {
      display: grid;
      grid-template-columns: 30% auto 10%;
    }

    .custom-form-set-meta-property {
      border-bottom: 1px solid var(--border-color);
    }

    .key-value-form .textarea:not([rows]) {
      min-height: 0.5rem;
    }
  </style>

  <div class="is-flex is-flex-direction-column gap-3">
    ${({ customFormTemplate }) => {
      if (customFormTemplate)
        return `<div class="custom-form-set-meta-property pb-5">${customFormTemplate}</div>`;
    }}
    ${({ noKeyValPairFields, keyValueFormTemplate }) => {
      if (!noKeyValPairFields) {
        return `<div class="key-value-form gap-3">${keyValueFormTemplate}</div>`;
      }
    }}
  </div>
`;

export const keyValueFormTemplate = htmlE`
  <div class="is-flex is-flex-direction-column gap-2">
    <label>
      <b class="text-primaryMain" data-i18n-key="key">Key</b>
      :
    </label>
    <input
      index="${({ index }) => utils.escapeHtmlAttr(index || "")}"
      class="input modal-input set-meta-key-input"
      name="key"
      value="${({ key }) => utils.escapeHtmlAttr(key || "")}" />
  </div>

  <div class="is-flex is-flex-direction-column gap-2">
    <label>
      <b class="text-primaryMain" data-i18n-key="value">Value</b>
      :
    </label>
    <textarea
      class="textarea set-meta-value-textarea"
      index="${({ index }) => utils.escapeHtmlAttr(index || "")}"
      row="1"
      name="value">
${({ value }) => utils.textEncode(value || "")}</textarea
    >
  </div>

  <div class="actions is-flex gap-3 is-justify-content-end">
    ${({ showAddIcon }) => {
      if (showAddIcon)
        return `<span class="icon mt-5 is-cursor-pointer addNewKeyValuePairButton"
        ><i class="icon-plus-sign text-success text-lg"></i
      ></span>`;
    }}
  </div>
`;

export const keyValueFormWithoutLabelTemplate = htmlE`
  <div class="is-flex is-flex-direction-column gap-1">
    <input index="${({ index }) =>
      utils.escapeHtmlAttr(
        index || ""
      )}" class="input modal-input set-meta-key-input" name="key" value="${({
  key,
}) => utils.escapeHtmlAttr(key || "")}"/>
  </div>

  <div class="is-flex is-flex-direction-column gap-1">
    <textarea class="textarea set-meta-value-textarea" index="${({ index }) =>
      utils.escapeHtmlAttr(index || "")}" row="1" name="value">${({ value }) =>
  utils.textEncode(value || "")}</textarea>
  </div>

  <div class="actions is-flex gap-3 is-justify-content-end">
    <span index="${"index"}" class="icon is-cursor-pointer removeKeyValuePairButton"
      ><i class="icon-minus-sign text-error text-lg"></i
    ></span>

    ${({ showAddIcon }) => {
      if (showAddIcon)
        return `<span class="icon is-cursor-pointer addNewKeyValuePairButton"
        ><i class="icon-plus-sign text-success text-lg"></i
      ></span>`;
    }}

  </div> `;

export default bodyTemplate;
